import { createElement } from 'react';
import { ResizerProps, useResizable } from '.';
import { useIsRTL } from '../../locale';
import { Icon } from '../Icon';
import { GrabberResizer } from '@sas/react-svg';
import bundle from './NovaComponents-Resizable-gui-icu.properties';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import cx from 'classnames';
import { renderInlineCssVars, useDesignTokens } from '../../theme';
import cn from './Resizable.css.json';
import './Resizable.css';

const useTextLocalizer = createUseTextLocalizer(bundle);

export const Resizer = ({
  tooltip,
  ariaLabel,
  className,
  style,
  resizableElementRef,
  onResize,
  testId,
  onMouseEnter,
  onMouseLeave,
}: ResizerProps) => {
  const isRTL = useIsRTL();
  const localize = useTextLocalizer();

  const { startResize, onArrowKeyResize, abortResize } = useResizable({
    ref: resizableElementRef,
    onResize,
  });

  const dt = useDesignTokens();

  const tokens = renderInlineCssVars(
    {
      'color-text-label': dt.c.colorTextLabel,
    },
    'resizer'
  );

  return (
    <div
      role="img"
      tabIndex={0}
      className={cx(cn.gripIconWrapper, isRTL && cn.gripCursorRtl, className)}
      style={style}
      onMouseDown={startResize}
      onKeyDown={onArrowKeyResize}
      onMouseUp={abortResize}
      data-testid={testId}
      title={tooltip ?? localize('gripIcon.label')}
      aria-label={ariaLabel ?? localize('gripIcon.aria')}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Icon icon={GrabberResizer} tooltip="" ariaLabel="" style={tokens} />
    </div>
  );
};
